<template>
  <div class="match-tab-filters">
    <div class="filter-wrap">
      <div class="filter-info">
        <span>{{ translations.select_entry_fee_range }}</span>
        <a v-if="false" href="#" class="filter-guide">{{
          translations.how_it_works
        }}</a>
      </div>
      <ul class="filters-list">
        <li
          v-for="(level, index) in entry_fee_filter"
          :key="index + 1"
          :class="[level.is_selected ? 'active' : '']"
          @click="level.is_selected ? () => !1 : setEntryFilterlevel(index)"
        >
          {{
            translations.entry_filter_level_labels &&
            translations.entry_filter_level_labels[index]
          }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { addPagePropertiesToObject, sendTrackingData } from "../../../assets/js/common";
import { CFG_TRACKING } from "../../../assets/js/config";
export default {
  computed: {
    entry_fee_filter: {
      get() {
        return this.$store.state.contest_store.entry_fee_filter;
      },
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    setEntryFilterlevel(index) {
      let toTrack = CFG_TRACKING["14"];
      toTrack.value = this.translations.entry_filter_level_labels[index];
      toTrack.label = this.translations.entry_filter_level_labels[index];
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);

      this.$store.dispatch("contest_store/applyEntryFeeFilter", {
        level: index,
      });
    },
  },
};
</script>